exports.version = "2.2.8"


//////////////////
// WEBPACK FOOTER
// /builds/development/frontend/widgets/widgets/node_modules/apollo-client/version.js
// module id = ../../node_modules/apollo-client/version.js
// module chunks = widget-7.1.6